import { Injectable, inject } from '@angular/core';
import { AccessControlService, AccessGrantRow } from '@6grain/masofa-monolith-api-client/identity';
import { Observable } from 'rxjs';

/** Process-scoped grant lookup through the generated identity client. */
@Injectable({ providedIn: 'root' })
export class AccessProcessGrantsService {
  private readonly api = inject(AccessControlService);

  forProcess(processKey: string): Observable<AccessGrantRow[]> {
    return this.api.identityAccessControlForProcessGet(processKey);
  }
}
